<div class="flex flex-column align-items-center justify-content-center animate-fade-in" style="min-height: 100dvh; padding: 2rem">
  <div class="w-full" style="max-width: 450px">
    <div class="text-center mb-5 animate-slide-up">
      <div class="mb-4">
        <div
          class="w-5rem h-5rem border-circle flex align-items-center justify-content-center shadow-soft animate-scale-in mx-auto"
          style="background-color: rgba(255, 255, 255, 0.15); backdrop-filter: blur(10px); border: 2px solid rgba(255, 255, 255, 0.2)"
        >
          <i class="pi pi-lock text-white text-3xl"></i>
        </div>
      </div>
      <h1 class="text-3xl md:text-4xl font-bold mb-2">Welcome to OAK Events</h1>
      <p class="text-lg">Sign in to manage check-ins</p>
    </div>

    <div class="card-modern p-5 shadow-soft animate-scale-in" style="animation-delay: 0.1s">
      <form [formGroup]="form">
        <div class="field mb-4">
          <label for="email" class="block text-900 font-medium mb-2">Email</label>
          <span class="p-input-icon-left w-full">
            <i class="pi pi-envelope"></i>
            <input
              (keydown)="clearMessage()"
              (ngModelChange)="clearMessage()"
              class="w-full"
              formControlName="email"
              id="email"
              pInputText
              type="email"
              autocapitalize="off"
              placeholder="Enter your email"
              [ngClass]="{ 'p-invalid': form.get('email')?.invalid && form.get('email')?.touched }"
            />
          </span>
          @if (form.get('email')?.invalid && form.get('email')?.touched) {
            <small class="p-error">Please enter a valid email</small>
          }
        </div>

        <div class="field mb-4">
          <label for="password" class="block text-900 font-medium mb-2">Password</label>
          <span class="p-input-icon-left w-full">
            <i class="pi pi-lock"></i>
            <input
              (keydown)="clearMessage()"
              (ngModelChange)="clearMessage()"
              class="w-full"
              formControlName="password"
              id="password"
              pInputText
              type="password"
              placeholder="Enter your password"
              [ngClass]="{ 'p-invalid': form.get('password')?.invalid && form.get('password')?.touched }"
            />
          </span>
          @if (form.get('password')?.invalid && form.get('password')?.touched) {
            <small class="p-error">Password is required</small>
          }
        </div>

        @if (this.message) {
          <div class="text-center mb-3">
            <p class="text-red-500 font-medium animate-fade-in">{{ this.message }}</p>
          </div>
        }
      </form>

      <div class="text-center mt-4">
        <p-button
          (onClick)="onLogin()"
          [disabled]="!this.form.valid"
          icon="pi pi-sign-in"
          label="Login"
          class="btn-modern"
          severity="success"
          [style]="{
            padding: '0.875rem 3rem',
            'font-size': '1.125rem',
            'font-weight': '600',
            'background-color': 'var(--primary-color)',
            'border-color': 'var(--primary-color)',
            color: 'white',
          }"
        ></p-button>
      </div>

      <div class="text-center mt-4">
        <p class="text-600">Need help? Contact your administrator</p>
      </div>
    </div>
  </div>
</div>
